import { Button, Spin } from 'antd';
import { billingSelectors, workSpaceSelectors } from 'containers/App/selectors';
import { Formik } from 'formik';
import { Form, Input, SubmitButton } from 'formik-antd';
import { setLoadStep2 } from 'pages/BillingProcess/slices';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { t_medical_institution } from '../../../types';
import { getItemLinkPSG, updatePsgDetailsCreate } from '../../BillingProcess/thunk';
import TableDataUser from './TableDataUser';
import { Wrapper } from './styles';

type Props = {
  nextStep: () => void;
  stepToPrevious: () => void;
};
type LocationState = {
  medicalDetail: t_medical_institution;
};

type InitialValues = {
  name_user: any;
  psg_remark: string;
  position?: number;
};

const BillingThirdStep: FC<Props> = ({ nextStep, stepToPrevious }) => {
  const dispatch = useDispatch();
  const location = useLocation<LocationState>();
  const { itemInvoice, itemPSGD6, loadStep2 } = useSelector(billingSelectors);
  const { statusBill } = useSelector(workSpaceSelectors);
  const [datePSG, setDatePSG] = useState<any>([]);

  useEffect(() => {
    dispatch(setLoadStep2(true));
    dispatch(
      getItemLinkPSG({
        invoice_id: itemInvoice?.invoice_id,
      }),
    );
  }, [itemInvoice?.invoice_id, dispatch]);

  const handleSubmit = (value: InitialValues, form: any) => {
    form.setSubmitting(false);
    const dataNew = {
      name: value.name_user,
      psg_remark: value.psg_remark,
      inspection_day: itemInvoice?.invoice_month,
      position: datePSG.length + 1,
    };
    setDatePSG([...datePSG, dataNew]);
    form.resetForm();
  };

  const handleSubmitPsg = async (statusBill: boolean | undefined) => {
    if (datePSG && !statusBill) {
      const params: any = {
        invoice_month: itemInvoice?.invoice_month,
        facility_id: location.state.medicalDetail.i_id,
      };
      const result: any = await dispatch(
        updatePsgDetailsCreate({
          item: params,
          invoice_id: itemInvoice?.i_id,
          return_item_result: true,
          datePSG: datePSG,
        }),
      );
      if (result.payload.error) return;
    }
    dispatch(
      getItemLinkPSG({
        invoice_id: itemInvoice?.invoice_id,
      }),
    );
    nextStep();
  };

  return (
    <Spin spinning={loadStep2} size="large">
      <Wrapper>
        <div className="section">
          <div className="extraLargeFont">3. 出張PSG検査明細作成</div>
          <div className="table-data-user">
            <TableDataUser
              data={[...(itemPSGD6 ?? []), ...datePSG]}
              dataNew={datePSG}
              setDatePSG={setDatePSG}
              statusBill={statusBill && statusBill.value === itemInvoice?.invoice_month}
            />
          </div>
          {statusBill?.value === itemInvoice?.invoice_month ? null : (
            <div className="add-statement">
              <div className="standardBoldFont text">明細を追加</div>
              <div>
                <Formik
                  onSubmit={handleSubmit}
                  initialValues={initialValues}
                  render={() => (
                    <Form layout="inline" className="form-add">
                      <Form.Item name="name_user">
                        <p className=" label-select standardBoldFont">ご利用者名</p>
                        <Input size={'large'} style={{ width: 196 }} name="name_user" />
                      </Form.Item>
                      <Form.Item name="psg_remark">
                        <p className="label-select standardBoldFont">備考</p>
                        <Input style={{ width: 442 }} size="large" name="psg_remark" />
                      </Form.Item>
                      <SubmitButton size={'large'} className="btn-sbm btn-add">
                        追加
                      </SubmitButton>
                    </Form>
                  )}
                />
              </div>
            </div>
          )}
          <div className="confirm-step">
            <Button onClick={stepToPrevious} className="btn-cancel-save">
              戻る
            </Button>
            <Button
              onClick={() => handleSubmitPsg(statusBill?.value === itemInvoice?.invoice_month)}
              className="btn-save"
            >
              {statusBill?.value === itemInvoice?.invoice_month ? '次へ' : '保存して次へ'}
            </Button>
          </div>
        </div>
      </Wrapper>
    </Spin>
  );
};

const initialValues = {
  name_user: '',
  psg_remark: '',
};

export default BillingThirdStep;
